<template>
  <div 
    class="xit-fb-template node condition-bg" 
    @dblclick.stop="handleClick(node)"
    :class="[camelCase(node.name), hasData(node), isSelected(node)]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-greater-than-equal card-condition-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">
      <div class="card-data">

         <p class="text-center mb-2 postback_title" v-if="getMatchType(node)">{{ match_type }}: {{getMatchType(node)}}</p>

         <div class="mb-4 mt-3" v-if="(node.data.system_field_variable && node.data.system_field_variable.filter(Boolean).length > 0)">
            <div class="section-title text-primary mb-2">{{ system_field }}</div>     
            <div :key="idx" v-for="(val, idx) in node.data.system_field_variable" class="condition-code pl-2">
              <p><i class="fas fa-question-circle text-primary text-small"></i> <span class="text-success">if</span> {{ node.data.system_field_variable_selected_texts[idx] }} <span class='text-danger'> {{ node.data.system_field_operator_selected_texts[idx] }} </span><span v-if="'gender' === val"> {{ node.data.system_field_gender_selected_texts[idx] }}</span><span v-else-if="'contact_group_id' === val"> {{ node.data.system_field_contact_group_id_selected_texts.join(', ') }}</span><span v-else> <span v-if="('has_value' !== node.data.system_field_operator[idx])"> {{ node.data.system_field_variable_value[idx] }}</span></span></p>              
            </div>
         </div>

         <div class="mb-0" v-if="(node.data.custom_field_variable_selected_values && node.data.custom_field_variable_selected_values.filter(Boolean).length > 0)">
            <div class="section-title text-primary mb-2">{{ custom_field  }}</div>     
            <div :key="idx" v-for="(val, idx) in node.data.custom_field_variable" class="condition-code pl-2">
              <p><i class="fas fa-question-circle text-primary text-small"></i> <span class="text-success">if</span> {{ node.data.custom_field_variable_selected_texts[idx] }} <span class='text-danger'> {{ node.data.custom_field_operator_selected_texts[idx] }} </span><span v-if="('has_value' !== node.data.custom_field_operator[idx])"> {{ node.data.custom_field_variable_value[idx] }}</span></p>              
            </div>
         </div>
      </div>

      <div class="card-sockets">
        <div class="output_content">
          <div class="output text-right" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
            <div class="output-title">{{output.name}}</div>
            <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
          </div>
        </div>
        <div class="input_content">
          <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
            <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
            <div class="input-title">{{input.name}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'
import { lang } from '../../assets/lang'
import { templateComponentMethods } from '../../functions/utils'

export default {
  name: 'ConditionTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    baseUrl: window.xitFlowBuilderData.base_url,
    all: lang.condition_template_all,
    any: lang.condition_template_any,
    match_type: lang.condition_template_match_type,
    system_field: lang.condition_template_system_field,
    custom_field: lang.condition_template_custom_field,
    operator: lang.condition_template_operator,
    variable: lang.condition_template_variable,
    value: lang.condition_template_value,
  }),
  methods: {
    ...templateComponentMethods,

    getMatchType(node) {
      return node.data.all_match ? this.all : (node.data.any_match ? this.any : '')
    },

    getSystemFieldVariableValue(node) {
      let value

      if ('gender' === node.data.system_field_variable) {
        value = node.data.system_field_gender_text
      } else if ('contact_group_id' === node.data.system_field_variable) {
        value = Array.isArray(node.data.system_field_contact_group_id_text_array) ? 
          node.data.system_field_contact_group_id_text_array.join(', ') : 
          ''
      } else {
        value = node.data.system_field_variable_value
      }
      
      return value
    }
  }
}
</script>

<style scoped>

.card-data div.title { font-size: 0.75rem; }
.card-data div p { line-height: 1rem; }
.typing_delay {background-color:#f6f4f4; border-radius: 7px;}
.typing_display_none {text-decoration: line-through; text-decoration-color: red;}
.input_content { width:50% !important;margin-top: 25px;}
.output_content{ width:50% !important;float:right !important;}
.card-sockets { padding: 5px 0 !important;}
.card-data-media { font-size: 14px; }
.card-data p {
  padding: 0;
  margin: 0;
}
</style>